import React, { useState } from 'react';
import useCircuitBreaker from '../../hooks/useCircuitBreaker';
import { processError } from '../../services/ServiceUtils';

/**
 * Faixa vermelha PERSISTENTE no topo da sidebar quando o circuit breaker está disparado
 * (automações pausadas por limite de drawdown). Impossível de ignorar — antes o estado só
 * aparecia como notificação no histórico, e o usuário podia achar que o bot estava operando.
 * Reset inline (mesma ação das Configurações). Some sozinha quando resetado.
 */
function CircuitBreakerIndicator() {
    const { active, resetting, reset } = useCircuitBreaker(30000);
    const [refusal, setRefusal] = useState('');

    if (!active) return null;

    // O backend RECUSA o reset logo após um reinício (base de patrimônio ainda não confiável) e
    // devolve o motivo. Antes o erro era engolido: o clique não fazia nada e ninguém sabia por quê.
    function onResetClick() {
        setRefusal('');
        reset().catch(err => setRefusal(processError(err) || 'Não foi possível resetar agora. Tente de novo em instantes.'));
    }

    return (
        <li className='nav-item mb-3'>
            <div className='rounded text-center px-2 py-2'
                style={{ background: '#dc3545', color: '#fff', boxShadow: '0 0 0 2px rgba(220,53,69,.45)' }}
                role='alert'>
                <div className='d-flex align-items-center justify-content-center gap-2 fw-bolder'>
                    <svg className='icon icon-xs flex-shrink-0' fill='none' stroke='currentColor' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
                        <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z' />
                    </svg>
                    <span className='sidebar-text'>CIRCUIT BREAKER ATIVO</span>
                </div>
                <div className='sidebar-text mt-1' style={{ fontSize: 11, opacity: 0.95 }}>
                    Automações pausadas (limite de drawdown). O bot NÃO está operando.
                </div>
                <button className='btn btn-sm btn-light fw-bold mt-2 w-100 sidebar-text' type='button'
                    onClick={onResetClick} disabled={resetting}>
                    {resetting ? 'Resetando...' : 'Resetar & Retomar'}
                </button>
                {refusal && (
                    <div className='sidebar-text mt-2 text-start' style={{ fontSize: 11, background: 'rgba(0,0,0,.18)', borderRadius: 4, padding: '4px 6px' }}>
                        {refusal}
                    </div>
                )}
            </div>
        </li>
    );
}

export default CircuitBreakerIndicator;
